export default "__VITE_ASSET__c8e62f06__"